import styles from "./winners.module.css";

const NoWinners = () => {
  return (
    <div className="grid justify-center mt-5 lg:mt-[47px]" data-testid="noWinnersContainer">
      <h3 className={`text-2xl ${styles.noWinnersHeader}`}>No winners found</h3>
      <p className="py-2">Watch this space...</p>
    </div>
  );
};

export default NoWinners;
